// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"270":"549fddf8","860":"97cb35ca"}[chunkId] + ".css";
};